<template>
	<div class="page-dashboard pa-1 relative">
		<div class="p-5 text-center absolute" v-if="isFetching">
			<div class="is-loading large"></div>
		</div>
		<div class="container-fluid" v-if="!isFetching">
			<!-- users -->
			<div><h2 class="text-primary mb-4">{{ $t('Users') }}</h2></div>
			<div class="cards-statistics">
				<div class="card-statistics">
					<div class="icon-statistics-wrapper"><md-icon class="icon-total-user ml-8px mt-2">groups</md-icon></div>
					<div class="text-statistics">
						<h1 class="text-count">{{statistics && statistics.total_user ? statistics.total_user : '0'}}</h1>
						<div>{{$t('Total User')}}</div>
					</div>
				</div>
				<div class="card-statistics">
					<div class="icon-statistics-wrapper"><md-icon class="icon-total-user ml-8px mt-2">groups</md-icon></div>
					<div class="text-statistics">
						<h1 class="text-count">{{statistics && statistics.total_subscription ? statistics.total_subscription : '0'}}</h1>
						<div>{{$t('Total User has Subscription')}}</div>
					</div>
				</div>
				<div class="card-statistics">
					<div class="icon-statistics-wrapper"><md-icon class="icon-total-user ml-8px mt-2">check</md-icon></div>
					<div class="text-statistics">
						<h1 class="text-count">{{statistics && statistics.total_user_verified ? statistics.total_user_verified : '0'}}</h1>
						<div>{{$t('Total User Verified')}}</div>
					</div>
				</div>
				<div class="card-statistics">
					<div class="icon-statistics-wrapper"><md-icon class="icon-total-user ml-8px mt-2">close</md-icon></div>
					<div class="text-statistics">
						<h1 class="text-count">{{statistics && statistics.total_user_unverified ? statistics.total_user_unverified : '0'}}</h1>
						<div>{{$t('Total User Unverified')}}</div>
					</div>
				</div>
				<div class="card-statistics">
					<div class="icon-statistics-wrapper"><md-icon class="icon-total-user ml-8px mt-2">person</md-icon></div>
					<div class="text-statistics">
						<h1 class="text-count">{{statistics && statistics.total_super_admin ? statistics.total_super_admin : '0'}}</h1>
						<div>{{$t('Total Super Admin')}}</div>
					</div>
				</div>
				<div class="card-statistics">
					<div class="icon-statistics-wrapper"><md-icon class="icon-total-user ml-8px mt-2">people</md-icon></div>
					<div class="text-statistics">
						<h1 class="text-count">{{statistics && statistics.total_client ? statistics.total_client : '0'}}</h1>
						<div>{{$t('Total Client')}}</div>
					</div>
				</div>
				<div class="card-statistics">
					<div class="icon-statistics-wrapper"><md-icon class="icon-total-user ml-8px mt-2">group_add</md-icon></div>
					<div class="text-statistics">
						<h1 class="text-count">{{statistics && statistics.total_collaborator ? statistics.total_collaborator : '0'}}</h1>
						<div>{{$t('Total Collaborator')}}</div>
					</div>
				</div>
				<div class="card-statistics">
					<div class="icon-statistics-wrapper"><md-icon class="icon-total-user ml-8px mt-2">feedback</md-icon></div>
					<div class="text-statistics">
						<h1 class="text-count">{{statistics && statistics.total_feedback ? statistics.total_feedback : '0'}}</h1>
						{{$t('Total Feedback')}}
					</div>
				</div>
				<div class="card-statistics">
					<div class="icon-statistics-wrapper"><md-icon class="icon-total-user ml-8px mt-2">person_add</md-icon></div>
					<div class="text-statistics">
						<h1 class="text-count">{{statistics && statistics.total_user_registered_today ? statistics.total_user_registered_today : '0'}}</h1>
						{{$t('Total User Registered Today')}}
					</div>
				</div>
				<div class="card-statistics">
					<div class="icon-statistics-wrapper"><md-icon class="icon-total-user ml-8px mt-2">person_add</md-icon></div>
					<div class="text-statistics">
						<h1 class="text-count">{{statistics && statistics.total_user_registered_this_week ? statistics.total_user_registered_this_week : '0'}}</h1>
						{{$t('Total User Registered this Week')}}
					</div>
				</div>
				<div class="card-statistics">
					<div class="icon-statistics-wrapper"><md-icon class="icon-total-user ml-8px mt-2">person_add</md-icon></div>
					<div class="text-statistics">
						<h1 class="text-count">{{statistics && statistics.total_user_registered_this_month  ? statistics.total_user_registered_this_month  : '0'}}</h1>
						{{$t('Total User Registered this Month')}}
					</div>
				</div>
			</div>
			<!-- General -->
			<div><h2 class="text-primary mb-4 mt-6">{{ $t('General') }}</h2></div>
			<div class="cards-statistics">
				<div class="card-statistics">
					<div class="icon-statistics-wrapper"><md-icon class="icon-total-user ml-8px mt-2">attach_money</md-icon></div>
					<div class="text-statistics">
						<h1 class="text-count">{{statistics && statistics.total_package ? statistics.total_package : '0'}}</h1>
						{{$t('Total Package')}}
					</div>
				</div>
				<div class="card-statistics">
					<div class="icon-statistics-wrapper"><md-icon class="icon-total-user ml-8px mt-2"><image-icon></image-icon></md-icon></div>
					<div class="text-statistics">
						<h1 class="text-count">{{statistics && statistics.total_media ? statistics.total_media : '0'}}</h1>
						{{$t('Total Media')}}
					</div>
				</div>
				<div class="card-statistics">
					<div class="icon-statistics-wrapper"><md-icon class="icon-total-user ml-8px mt-2">description</md-icon></div>
					<div class="text-statistics">
						<h1 class="text-count">{{statistics && statistics.total_template ? statistics.total_template : '0'}}</h1>
						{{$t('Total Template')}}
					</div>
				</div>
				<div class="card-statistics">
					<div class="icon-statistics-wrapper"><md-icon class="icon-total-user ml-8px mt-2">monitor</md-icon></div>
					<div class="text-statistics">
						<h1 class="text-count">{{statistics && statistics.total_display ? statistics.total_display : '0'}}</h1>
						{{$t('Total Display')}}
					</div>
				</div>
				<div class="card-statistics">
					<div class="icon-statistics-wrapper"><md-icon class="icon-total-user ml-8px mt-2">fullscreen</md-icon></div>
					<div class="text-statistics">
						<h1 class="text-count">{{statistics && statistics.total_display_size ? statistics.total_display_size : '0'}}</h1>
						{{$t('Total Display Size')}}
					</div>
				</div>
			</div>
			<!-- rundown and assets -->
			<div><h2 class="text-primary mb-4 mt-6">{{ $t('Rundown & Assets') }}</h2></div>
			<div class="cards-statistics">
				<div class="card-statistics">
					<div class="icon-statistics-wrapper"><md-icon class="icon-total-user ml-8px mt-2">playlist_add_check</md-icon></div>
					<div class="text-statistics">
						<h1 class="text-count">{{statistics && statistics.total_rundown ? statistics.total_rundown : '0'}}</h1>
						{{$t('Total Rundown')}}
					</div>
				</div>
				<div class="card-statistics">
					<div class="icon-statistics-wrapper"><md-icon class="icon-total-user ml-8px mt-2">play_arrow</md-icon></div>
					<div class="text-statistics">
						<h1 class="text-count">{{statistics && statistics.total_rundown_item ? statistics.total_rundown_item : '0'}}</h1>
						{{$t('Total Rundown Assets')}}
					</div>
				</div>
				<div class="card-statistics">
					<div class="icon-statistics-wrapper"><md-icon class="icon-total-user ml-8px mt-2"><alpha-a-icon></alpha-a-icon></md-icon></div>
					<div class="text-statistics">
						<h1 class="text-count">{{statistics && statistics.total_rundown_item_lower_third ? statistics.total_rundown_item_lower_third : '0'}}</h1>
						{{$t('Total Rundown Assets Lower Third')}}
					</div>
				</div>
				<div class="card-statistics">
					<div class="icon-statistics-wrapper"><md-icon class="icon-total-user ml-8px mt-2"><image-icon></image-icon></md-icon></div>
					<div class="text-statistics">
						<h1 class="text-count">{{statistics && statistics.total_rundown_item_media ? statistics.total_rundown_item_media : '0'}}</h1>
						{{$t('Total Rundown Assets Media')}}
					</div>
				</div>
				<div class="card-statistics">
					<div class="icon-statistics-wrapper"><md-icon class="icon-total-user ml-8px mt-2"><earth-icon></earth-icon></md-icon></div>
					<div class="text-statistics">
						<h1 class="text-count">{{statistics && statistics.total_rundown_item_browser_source ? statistics.total_rundown_item_browser_source : '0'}}</h1>
						{{$t('Total Rundown Assets Browser Source')}}
					</div>
				</div>
				<div class="card-statistics">
					<div class="icon-statistics-wrapper"><md-icon class="icon-total-user ml-8px mt-2"><clock-icon></clock-icon></md-icon></div>
					<div class="text-statistics">
						<h1 class="text-count">{{statistics && statistics.total_rundown_item_timer ? statistics.total_rundown_item_timer : '0'}}</h1>
						{{$t('Total Rundown Assets Timer')}}
					</div>
				</div>
				<div class="card-statistics">
					<div class="icon-statistics-wrapper"><md-icon class="icon-total-user ml-8px mt-2"><format-size-icon></format-size-icon></md-icon></div>
					<div class="text-statistics">
						<h1 class="text-count">{{statistics && statistics.total_rundown_item_ticker ? statistics.total_rundown_item_ticker : '0'}}</h1>
						{{$t('Total Rundown Assets Ticker')}}
					</div>
				</div>
				<div class="card-statistics">
					<div class="icon-statistics-wrapper"><md-icon class="icon-total-user ml-8px mt-2"><radio-tower-icon></radio-tower-icon></md-icon></div>
					<div class="text-statistics">
						<h1 class="text-count">{{statistics && statistics.total_rundown_item_zoom_meeting ? statistics.total_rundown_item_zoom_meeting : '0'}}</h1>
						{{$t('Total Rundown Assets Zoom Meeting')}}
					</div>
				</div>
				<div class="card-statistics">
					<div class="icon-statistics-wrapper"><md-icon class="icon-total-user ml-8px mt-2"><video-icon></video-icon></md-icon></div>
					<div class="text-statistics">
						<h1 class="text-count">{{statistics && statistics.total_rundown_item_video_input ? statistics.total_rundown_item_video_input : '0'}}</h1>
						{{$t('Total Rundown Assets Video Input')}}
					</div>
				</div>
				<div class="card-statistics">
					<div class="icon-statistics-wrapper"><md-icon class="icon-total-user ml-8px mt-2"><transition-icon></transition-icon></md-icon></div>
					<div class="text-statistics">
						<h1 class="text-count">{{statistics && statistics.total_rundown_item_lottie ? statistics.total_rundown_item_lottie : '0'}}</h1>
						{{$t('Total Rundown Assets Lottie')}}
					</div>
				</div>
				<div class="card-statistics">
					<div class="icon-statistics-wrapper"><md-icon class="icon-total-user ml-8px mt-2"><picture-in-picture-icon></picture-in-picture-icon></md-icon></div>
					<div class="text-statistics">
						<h1 class="text-count">{{statistics && statistics.total_rundown_item_composition ? statistics.total_rundown_item_composition : '0'}}</h1>
						{{$t('Total Rundown Assets Composition')}}
					</div>
				</div>
				<div class="card-statistics">
					<div class="icon-statistics-wrapper"><md-icon class="icon-total-user ml-8px mt-2">play_arrow</md-icon></div>
					<div class="text-statistics">
						<h1 class="text-count">{{statistics && statistics.total_macro ? statistics.total_macro : '0'}}</h1>
						{{$t('Total Macro')}}
					</div>
				</div>
			</div>
			<!-- most used assets -->
			<div class="row">
				<!-- lower third -->
				<div class="col-lg-3">
					<h4 class="text-primary mb-4 mt-6">{{ $t('Popular Lower Third') }}</h4>
					<table class="table table-striped mb-4" v-if="!isFetchingTemplate">
						<tbody>
							<tr
							v-for="(item) in templates"
							:key="item.id">
								<td class="d-flex justify-content-between">
									<div class="truncate-most-popular-name">{{item.name}}</div>
									<div>{{item.total_use}}</div>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<!-- medias -->
				<div class="col-lg-3">
					<h4 class="text-primary mb-4 mt-6">{{ $t('Popular Media') }}</h4>
					<table class="table table-striped mb-4" v-if="!isFetchingMedia">
						<tbody>
							<tr
							v-for="(item) in medias"
							:key="item.id">
								<td class="d-flex justify-content-between">
									<div class="truncate-most-popular-name">{{item.name}}</div>
									<div>{{item.total_use}}</div>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<!-- lottie -->
				<div class="col-lg-3">
					<h4 class="text-primary mb-4 mt-6">{{ $t('Popular Lottie') }}</h4>
					<table class="table table-striped mb-4" v-if="!isFetchingTemplate">
						<tbody>
							<tr
							v-for="(item) in lotties"
							:key="item.id">
								<td class="d-flex justify-content-between">
									<div class="truncate-most-popular-name">{{item.name}}</div>
									<div>{{item.total_use}}</div>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import EarthIcon from 'vue-material-design-icons/Earth.vue';
import ImageIcon from 'vue-material-design-icons/Image.vue';
import AlphaAIcon from 'vue-material-design-icons/AlphaA.vue';
import FormatSizeIcon from 'vue-material-design-icons/FormatSize.vue';
import RadioTowerIcon from 'vue-material-design-icons/RadioTower.vue';
import VideoIcon from 'vue-material-design-icons/Video.vue';
import ClockIcon from 'vue-material-design-icons/Clock.vue';
import PictureInPictureIcon from 'vue-material-design-icons/PictureInPictureBottomRightOutline.vue';
import TransitionIcon from 'vue-material-design-icons/Transition.vue';
import { getAxiosErrorMessage } from '@/lib/helper';
import statisticsApi from '@/api/statistics';
import mediasApi from '@/api/medias';
import templatesApi from '@/api/templates';

export default {
	name: 'Statistics',
	data() {
		return {
			statistics: [],
			isFetching: false,
			isFetchingMedia: false,
			isFetchingTemplate: false,
			isFetchingLottie: false,
			templates: [],
			lotties: [],
			medias: [],
		};
	},
	components: {
		EarthIcon,
		ImageIcon,
		AlphaAIcon,
		FormatSizeIcon,
		RadioTowerIcon,
		VideoIcon,
		ClockIcon,
		PictureInPictureIcon,
		TransitionIcon,
	},
	props: {
	},
	methods: {
		fetch() {
			this.isFetching = true;
			const callback = (response) => {
				const items = response.data;
				this.statistics = items;
				this.isFetching = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Users',
					text: message,
				});
				this.isFetching = false;
			};
			statisticsApi.getStatistics(callback, errorCallback);
		},
		fetchMedia() {
			this.isFetchingMedia = true;
			const params = {
				page: 1,
				limit: 8,
				order_by: 'total_use',
				sort_by: 'desc',
				not_type: ['lottie', 'audio'],
			};
			const callback = (response) => {
				const medias = response.data;
				this.medias = medias;
				this.isFetchingMedia = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Gallery Media',
					text: message,
				});
				this.isFetchingMedia = false;
			};
			mediasApi.getList(params, callback, errorCallback);
		},
		fetchTemplate() {
			this.isFetchingTemplate = true;
			const params = {
				page: 1,
				limit: 8,
				order_by: 'total_use',
				sort_by: 'desc',
				type: 'lower_third',
			};
			const callback = (response) => {
				const templates = response.data;
				this.templates = templates;
				this.isFetchingTemplate = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Gallery Media',
					text: message,
				});
				this.isFetchingTemplate = false;
			};
			templatesApi.getList(params, callback, errorCallback);
		},
		fetchLottie() {
			this.isFetchingLottie = true;
			const params = {
				page: 1,
				limit: 8,
				order_by: 'total_use',
				sort_by: 'desc',
				type: 'lottie',
			};
			const callback = (response) => {
				const lotties = response.data;
				this.lotties = lotties;
				this.isFetchingLottie = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Gallery Media',
					text: message,
				});
				this.isFetchingLottie = false;
			};
			mediasApi.getList(params, callback, errorCallback);
		},
	},
	created() {
		this.fetch();
		this.fetchTemplate();
		this.fetchMedia();
		this.fetchLottie();
	},
	computed: {
	},
	watch: {
	},
};
</script>
